
import ImageAnnotator from './image-annotator.vue';

export default {
    components: {
        ImageAnnotator,
    },
    props: {

        taskId: {
            type: Number,
            required: true,
        },
    },

    created() {

        let t = this;

        t.loadData();

    },
    activated() {
        let t = this;
    },
    methods: {

        loadData() {
            let t = this;

            axios.get('cleanArea?_with=items').then(res => {
                if (res.data.status == 1) {
                    let items = res.data.options.items;
                    items.forEach(item => {
                        item.remark = '';
                    });
                    t.list.cleanArea = items;

                    axios.get('cleanTask?_with=room,order,results,roomCleanAreas&task_id=' + t.taskId).then(res => {
                        if (res.data.status == 1) {
                            let arr = res.data.options.items;
                            t.editTaskItem(arr[0]);
                        }
                    });
                }
            });


        },


        editTaskItem(item) {

            let t = this;

            t.currentTask = item;

            let arr = [];

            let selectedIds = [];
            let dictAreaImgs = {};
            let dictAreaRemark = {};
            let dictAreaPassed = {};
            let dictAreaPrev = {};

            if (t.currentTask.results && t.currentTask.results.length > 0) {
                t.currentTask.results.forEach(res => {
                    if (res.selection) {
                        selectedIds.append(res.selection.split(','));
                    }
                    if (res.img_urls) {
                        dictAreaImgs[res.area_id] = res.img_urls.split(',');
                    }
                     if (res.remark) {
                        dictAreaRemark[res.area_id] = res.remark;
                    }
                    dictAreaPassed[res.area_id] = (res.passed_imgs || '').split(',').filter(u => u);
                    dictAreaPrev[res.area_id] = (res.prev_img_urls || '').split(',');
                });
            }

            let dictRCA = {};

            t.currentTask.room_clean_areas.forEach(rca => {
                dictRCA[rca.area_id] = rca;
            });

            t.list.cleanArea.forEach(area => {

                area.imgs = [];
                area.columns = [];
                area.passedImgs = dictAreaPassed[area.id] || [];
                area.prevImgs = dictAreaPrev[area.id] || [];
                area.showPrev = [];

                area.items.forEach(item => {
                    item.selected = false;

                    if (selectedIds.indexOf(item.id.toString()) > -1)
                        item.selected = true;
                });

                if (dictAreaImgs[area.id]) {
                    area.imgs = dictAreaImgs[area.id];
                }

                 if (dictAreaRemark[area.id]) {
                    area.remark = dictAreaRemark[area.id];
                }

                if (area.column == 1) {
                    area.columns.push(area.items);
                }
                else if (area.column == 2) {
                    let rows = area.rows.split(',');
                    area.columns.push(area.items.slice(0, Number(rows[0])));
                    area.columns.push(area.items.slice(Number(rows[0]), Number(rows[1]) + Number(rows[0])));
                }

                let rca = dictRCA[area.id];

                if (rca && rca.quantity > 0) {
                    area.quantity = rca.quantity;
                    arr.push(area);
                }

            });

            t.list.roomArea = arr;

        },

        displayImg(area, j) {
            if (area.showPrev && area.showPrev[j] && area.prevImgs && area.prevImgs[j])
                return area.prevImgs[j];
            return area.imgs[j];
        },

        isPassed(area, j) {
            if (!area.passedImgs || !area.imgs || !area.imgs[j])
                return false;
            return area.passedImgs.indexOf(area.imgs[j]) > -1;
        },

        togglePassed(area, j) {
            let t = this;
            if (!t.currentTask || t.currentTask.status != 3)
                return;
            let img = area.imgs[j];
            if (!img)
                return;
            if (!area.passedImgs)
                area.passedImgs = [];
            let idx = area.passedImgs.indexOf(img);
            if (idx > -1) {
                area.passedImgs.splice(idx, 1);
            } else {
                area.passedImgs.push(img);
            }
            axios.post('cleanTask/saveResult', {
                task_id: t.currentTask.id,
                area_id: area.id,
                passed_imgs: area.passedImgs.join(',')
            });
        },

        togglePrev(area, j) {
            let t = this;
            if (!area.prevImgs || !area.prevImgs[j])
                return;
            if (!area.showPrev)
                area.showPrev = [];
            t.$set(area.showPrev, j, !area.showPrev[j]);
        },

        preview(area, idx) {

            let t = this;
            let images = [];
            let names = [];
            let meta = [];
            let start = 0;

            t.list.roomArea.forEach(a => {
                (a.imgs || []).forEach((img, j) => {
                    if (a === area && j === idx) {
                        start = images.length;
                    }
                    let isPrev = !!(a.showPrev && a.showPrev[j] && a.prevImgs && a.prevImgs[j]);
                    images.push(t.url(t.displayImg(a, j)));
                    names.push(a.name);
                    meta.push({ area: a, j: j, isPrev: isPrev });
                });
            });

            if (images.length === 0) {
                return;
            }

            t.previewImages = images;
            t.previewNames = names;
            t.previewMeta = meta;
            t.previewIndex = start;
            t.previewTitle = names[start] || '';
            t.showPreview = false;
            t.$nextTick(() => {
                t.showPreview = true;
            });
        },

        onPreviewChange(index) {
            let t = this;
            t.previewIndex = index;
            t.previewTitle = t.previewNames[index] || '';
        },

        openAnnotator() {
            let t = this;
            if (!t.canAnnotate) {
                return;
            }
            t.annotateSrc = t.previewImages[t.previewIndex];
            t.showAnnotator = true;
        },

        closeAnnotator() {
            this.showAnnotator = false;
            this.annotatorBusy = false;
        },

        onAnnotateConfirm(blob) {
            let t = this;
            let meta = t.previewMeta[t.previewIndex];
            if (!meta || !blob) {
                return;
            }

            let area = meta.area;
            let oldUrl = area.imgs[meta.j];
            let oldPassed = (area.passedImgs || []).slice();

            t.annotatorBusy = true;

            let fd = new FormData();
            fd.append('image_0', blob, 'annotated.jpg');
            fd.append('qty', 1);
            fd.append('task_id', t.currentTask.id);

            axios.post('cleanTask/saveMultipleImage', fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then(res => {
                if (res.data.status != 1) {
                    throw new Error('upload');
                }

                let urls = res.data.options.img_urls;
                let newUrl = urls;
                if (Object.prototype.toString.call(urls) === '[object Array]') {
                    newUrl = urls.length > 0 ? urls[0] : '';
                } else if (typeof urls === 'string') {
                    newUrl = urls.split(',')[0];
                }
                if (!newUrl) {
                    throw new Error('upload');
                }

                t.$set(area.imgs, meta.j, newUrl);

                if (area.passedImgs && oldUrl) {
                    let pidx = area.passedImgs.indexOf(oldUrl);
                    if (pidx > -1) {
                        t.$set(area.passedImgs, pidx, newUrl);
                    }
                }

                let payload = {
                    task_id: t.currentTask.id,
                    area_id: area.id,
                    img_urls: area.imgs.join(','),
                };
                if (area.passedImgs) {
                    payload.passed_imgs = area.passedImgs.join(',');
                }

                return axios.post('cleanTask/saveResult', payload).then(res2 => {
                    if (res2.data.status != 1) {
                        throw new Error('save');
                    }
                    t.$set(t.previewImages, t.previewIndex, t.url(newUrl));
                    t.closeAnnotator();
                    t.$forceUpdate();
                });
            }).catch(() => {
                t.$set(area.imgs, meta.j, oldUrl);
                t.$set(area, 'passedImgs', oldPassed);
                t.annotatorBusy = false;
                A.toast('保存に失敗しました');
            });
        },

        reset() {

            let t = this;

            if (t.busying)
                return;

            t.busying = true;

            A.safety('このレポートが返送されることを確認しますか？').then(res => {
                t.busying = false;

                if (res.isConfirmed) {

                    let f = {
                    };

                    let json = {};
                    let jsonPassed = {};

                    t.list.roomArea.forEach(item => {
                        json[item.id] = item.remark;
                        jsonPassed[item.id] = (item.passedImgs || []).join(',');
                    });

                    f.remark_json = JSON.stringify(json);
                    f.passed_json = JSON.stringify(jsonPassed);

                    axios.post('cleanTask/reset/' + t.currentTask.id, f).then(res => {
                        if (res.data.status == 1) {
                            t.currentTask.status = 2;
                            t.currentTask.is_finish = 2;
                            t.$emit('reset');
                            A.toast('それは送り返された。');
                        }
                    });
                }
            });



        },

        setFinish() {

            let t = this;

            if (t.busying)
                return;

            t.busying = true;

            axios.put('cleanTask/' + t.currentTask.id, { 'is_finish': 1 }).then(res => {

                t.busying = false;

                if (res.data.status == 1) {
                    t.currentTask.is_finish = 1;
                    t.$emit('finish');
                    A.toast('Saved.');
                }
            });

        },

    },
    data() {
        return {
            loading: false,
            currentTask: null,
            list: {
                cleanArea: [],
                roomArea: [],
            },
            showPreview: false,
            previewImages: [],
            previewNames: [],
            previewMeta: [],
            previewIndex: 0,
            previewTitle: '',
            showAnnotator: false,
            annotateSrc: '',
            annotatorBusy: false,
        };
    },
    computed: {
        canAnnotate() {
            let t = this;
            if (!t.currentTask || t.currentTask.status != 3) {
                return false;
            }
            let meta = t.previewMeta[t.previewIndex];
            if (!meta || meta.isPrev) {
                return false;
            }
            return true;
        },
        submitTime() {
            let t = this;
            if (!t.currentTask) {
                return '';
            }

            let time = '';
            if (t.currentTask.results && t.currentTask.results.length > 0) {
                t.currentTask.results.forEach(res => {
                    let ts = res.updated_at || res.created_at;
                    if (ts && ts > time) {
                        time = ts;
                    }
                });
            }

            time = time || t.currentTask.updated_at || '';
            if (!time) {
                return '';
            }

            return new Date(time).format('yyyy/MM/dd hh:mm');
        }
    }
};
